import { InstagramIcon } from "kosmos-ui/lib";

import { GithubIcon, LinkedInIcon } from "app/assets/icons";
import ZeroheightIcon from "app/assets/icons/Zeroheight";

import {
  Container,
  ContentContainer,
  LinksContainer,
  CopyrightContainer,
  Paragraph,
  SocialMedia,
  SectionsContainer,
  Link,
} from "./styles";

export default function Footer() {
  const copyrightDate = new Date();
  const copyrightYear = copyrightDate.getFullYear();

  return (
    <Container>
      <ContentContainer>
        <CopyrightContainer>
          <Paragraph style={{ margin: "0 16px", textAlign: "left" }}>
            © {copyrightYear} Grafito - Diseñado en Chile
          </Paragraph>
        </CopyrightContainer>

        <LinksContainer>
          <Link to="/about">Nosotros</Link>
          <Link to="/join">Entrar como marca</Link>
          <Link to="/changelog">Changelog</Link>
        </LinksContainer>

        <SectionsContainer>
          <SocialMedia href="https://www.instagram.com/grafito.app/">
            <InstagramIcon height="24px" color="#8f9ab7" />
          </SocialMedia>

          <SocialMedia href="https://www.linkedin.com/company/71194720">
            <LinkedInIcon height="24px" />
          </SocialMedia>

          <SocialMedia href="https://github.com/grafito-app">
            <GithubIcon height="24px" />
          </SocialMedia>

          <SocialMedia href="https://zeroheight.com/2ea641f16">
            <ZeroheightIcon height="24px" color="#8f9ab7" />
          </SocialMedia>
        </SectionsContainer>
      </ContentContainer>
    </Container>
  );
}
